module.exports = __webpack_public_path__ + "img/inactivar.0df6b45c.svg";